export default __webpack_public_path__ + "static/media/oasis.479b929d.jpg";